<template>
  <div>
    <v-menu offset-y v-if="admin"
            :nudge-width="200"
    >
      <template v-slot:activator="{ on, attrs }">
        <v-btn
            v-bind="attrs"
            v-on="on"
            text
        >
          <v-icon>mdi-account-circle</v-icon>

          <div v-if="contestantId">
            <span class="mr-2">{{ gameStatus.contestants[contestantId].name }}</span>
          </div>
          <div v-else>
            <span class="mr-2" >Quiz Master</span>
          </div>
        </v-btn>
      </template>
      <v-list>

        <v-list-item
            @click="setContestant(null)"
        >
          <v-list-item-icon>
            <v-icon>mdi-account-cog</v-icon>
          </v-list-item-icon>
          <v-list-item-content>
            <v-list-item-title>
              Quiz Master
            </v-list-item-title>
          </v-list-item-content>
        </v-list-item>

        <v-divider/>

        <v-list-item
            v-for="contestant in gameStatus.contestants" :key="contestant.id"
            @click="setContestant(contestant.id)"
        >
          <v-list-item-icon>
            <v-icon>mdi-account</v-icon>
          </v-list-item-icon>
          <v-list-item-content>
            <v-list-item-title>
              {{ contestant.name }}
            </v-list-item-title>
          </v-list-item-content>
        </v-list-item>

      </v-list>
    </v-menu>
    <div v-else>
      <v-btn
          text
      >
        <div v-if="contestantId">
          <span class="mr-2">{{ gameStatus.contestants[contestantId].name }}</span>
        </div>

        <v-icon>mdi-account-circle</v-icon>
      </v-btn>
    </div>

  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';

export default {
  name: 'UserSelector',
  computed: mapGetters(['admin', 'gameStatus', 'contestantId']),
  methods: {
    ...mapActions(['setContestant']),
  }
}
</script>
